export enum DeviceHeartbeatStatus {
    DISCONNECTED = "DISCONNECTED",
    CONNECTED = "CONNECTED",
    UNKNOWN = "UNKNOWN",
}
